import { Component, OnInit, ViewChild, EventEmitter, Output, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { Asset } from "src/app/models/asset";
import { Comment } from "src/app/models/comment";
import { HttpService } from "src/app/modules/assetModule/shared/services/http.service";
import { AssetFile } from "src/app/models/assetFile";
import { ActivatedRoute, Router } from "@angular/router";
import { LibraryBrowserComponent } from "../library-browser/library-browser.component";
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { ConfigService } from "src/app/shared/services/config.service";
import { AssetFileSpecification } from "src/app/models/assetFileSpecification";
import { Validators, FormControl } from "@angular/forms";
import { Location } from "@angular/common";
import { AssetCardDetails } from "src/app/models/assetCardDetails";
import { RatingComponent } from "src/app/shared/components/rating/rating.component";
import { Tokens } from "src/app/models/tokens";
import { SortAssetsBy } from "src/app/models/SortAssetsBy";
import { FolderStructure } from "src/app/models/FolderStructure";
import { FolderLevel } from "src/app/models/folderLevel";
import { PersonalFilter, CustomFilter, Category } from "src/app/models/PersonalFilter";
import { AssetInformationComponent } from "../asset-information/asset-information.component";

@Component({
  selector: "app-search-lib",
  templateUrl: "./search-lib.component.html",
  styleUrls: ["./search-lib.component.css"]
})
export class SearchLibComponent implements OnInit, OnDestroy {
  resrtictionType = ["Not Commercially Ready", "Commercially Ready", "Product is Development"];
  @Output()
  uneditedAssetEmit: EventEmitter<Asset> = new EventEmitter<Asset>();
  selectedAsset: AssetFile;
  @ViewChild(RatingComponent) starRate: RatingComponent;
  @ViewChild(AssetInformationComponent) assetInfo: AssetInformationComponent;
  downloadValue = 20;
  attributes;
  asset: Asset = new Asset();
  assetRemixed: Asset = new Asset();
  remix = false;
  comments: Array<Comment> = new Array<Comment>();
  library;
  formats = [];
  quality = [];
  textureQuality = [];
  assetIdParms: string;
  assetFolderParams: string;
  showEdit = false;
  loader = false;
  edit = false;
  updateText = "Modify";
  panDisplay = "expanded";

  filterList: Map<any, any> = new Map<any, any>();
  contextmenu = false;
  contextmenuX = 0;
  contextmenuY = 0;
  searchKey = "";
  assetFilePath: string = "";
  loadAsset = true;
  assetSuggestion = 1;
  versionList = [];
  selectedVersion: string;
  assetsInAVertion: Array<AssetFile> = new Array<AssetFile>();
  assetsInFormats: Array<AssetFile> = new Array<AssetFile>();
  assetFileSpecifaction: AssetFileSpecification = new AssetFileSpecification();
  primaryContactNameControl = new FormControl("", [Validators.required]);
  primaryContactEmailControl = new FormControl("", [
    Validators.email,
    Validators.required,
    Validators.pattern(".*@siemens-healthineers.com")
  ]);
  filterNameControl = new FormControl("", [Validators.required, Validators.minLength(1)]);
  uneditedAsset: Asset = new Asset();
  unEditedAssetFile: AssetFile;
  validVersions: number;
  searchResults: any;
  assetsCardDetails: Array<AssetCardDetails>;
  isPersonalBrowser = false;
  experiencedMode;
  isUploadClicked = false;
  emitOverlayDetailsAssetShow = false;
  showSpecifications = false;
  renameEnable = false;
  editDescriptionEnable = false;
  assetNameError = false;
  assetNameExists = false;
  editedAssetName = "";
  editedDescription = "";
  filePath = "";
  downloadStarted = false;
  snapshotImage = [];
  uploadedImages = [];
  previewBackgroundColor = "";
  downloadAssetLevel = "Download Asset";
  uploadToken = false;
  downloadToken = false;
  deleteToken = false;
  modifyToken = false;
  usertokens = new Map();
  @ViewChild('libBrowser') libBrowser: LibraryBrowserComponent;
  selectedSort: string = null;
  searchInFolder: string = null;
  searchedResults: any;
  searchAssetLibrary = false;
  showAssetCategory = false;
  selectedBusinessFolders = [];
  selectedProductFamilyFolders = [];
  selectedProductFolders = [];
  selectedConfigurationFolders = [];
  targ: string = "";
  /**Variables used for implementing filter */
  filterTagsArr: string[] = [];
  selectedExtension: string;
  extension: string[] = [];
  restriction: string[] = [];
  tag: string[] = [];
  filterMap = new Map();
  parentFolderId: string = "";
  searchKeyForFilter: string;
  filterSelectionValues: object;
  browserRefresh = false;
  params = '';
  breadCrumbClicked = false;
  folderbreadcrumbclicked = false;
  parameter = '';
  remixes = false;
  arrayParams = [];
  isExtensionExpanded = false;
  isRestrictionExpanded = false;
  isTagExpanded = false;
  folderStructure: Array<FolderStructure>;
  businessStructure: Array<FolderStructure> = [];
  productFamily: Array<FolderStructure> = [];
  product: Array<FolderStructure> = [];
  configurationFolders: Array<FolderStructure> = [];
  masterBusinessStructure: Array<FolderStructure> = [];
  masterProductFamily: Array<FolderStructure> = [];
  masterProduct: Array<FolderStructure> = [];
  masterConfiguration: Array<FolderStructure> = [];
  selectedFilter: string = null;
  checkedExtension = [];
  checkedRestrictions: string[] = [];
  checkedTags = [];
  remixedFromAsset: Array<AssetCardDetails> = new Array<AssetCardDetails>();
  remixedFromAssetList: Array<AssetCardDetails> = new Array<AssetCardDetails>();
  isShowMoreVisible: boolean = false;
  isConsentFormSelected = false;
  isConsentFormDownloadPermission = false;
  @ViewChildren("extensionCheckboxes") extensionCheckboxes: QueryList<ElementRef>;
  @ViewChildren("restrictionCheckboxes") restrictionCheckboxes: QueryList<ElementRef>;
  @ViewChildren("tagCheckboxes") tagCheckboxes: QueryList<ElementRef>;
  @ViewChild('folderShow') folderShow: ElementRef;
  assetNameRegExp = new RegExp('^[a-zA-Z0-9-_ ]+$');
  filterKeys: any
  assetNameValidFlg = false;
  isConfigurationVisible = false;
  personalFilter: PersonalFilter;
  loaded: boolean = false;
  sortKey: SortAssetsBy = 0;
  filterNameValidFlag: boolean = false;
  showFailure: boolean = false;
  showSuccess: boolean = false;
  showSuccessMessage: string;
  showFailureMessage: string;
  tempFilter: any;
  maxFilter: boolean = false;
  values: string = "";
  assetProfileImageURL: string = 'assets/img/userDefault.png';

  //Advance Filters
  da: any;
  dateModified: any = "All";
  datePublished: any = "All";
  enableCustomSize: boolean = false;
  enableCustomDateModified: boolean = false;
  enableCustomDatePublished: boolean = false;
  radioGroupValue: number = 0;
  customFileSize: number = 0;
  customModifiedDate: any;
  customPublishedDate: any;

  prodStatus: number;

  theme_color: string;
  selectedFoldersToSearch: string = '';
  isDisplayTags: boolean = false;
  previouseMenu: any;
  Uploader: string;
  enableDownloadButtonForAsset: boolean;
  applications: any = [];
  isAdminUser: boolean = false;
  changeSearchResultSubscription: any;

  /**----------------- */
  constructor(
    public httpService: HttpService,
    private activatedRoute: ActivatedRoute,
    public userService: UserService,
    private config: ConfigService,
    private location: Location,
    private router: Router,
    private ref: ChangeDetectorRef) {
    this.httpService.fetchAsset.subscribe((assetId) => {
      this.attributes = {};
      this.formats = [];
      this.quality = [];
      this.textureQuality = [];
      this.versionList = [];
      this.getAssetById(assetId);
    }
    );
  }

  ngAfterViewInit() {
    this.config.searchActive = false;
    this.config.homeActive = false;
    this.config.personalBrowserActive = false;
    this.config.uploadAssetsActive = false;

    let url = this.router.url;

    if (url.indexOf('personal-browser') > 0) {
      this.config.personalBrowserActive = true;
    } else {
      this.config.searchActive = true;
    }
    this.httpService.folderCategory.subscribe(folder =>
      this.showAssetCategory = folder.isFolder);

    this.ref.detectChanges();

    // if (this.showAssetCategory) {
    //   this.getAssetCategory();
    // }

  }

  ngOnInit() {
    this.httpService.themeChange.subscribe(
      data => {
        this.theme_color = data.themeType;
        if (this.previewBackgroundColor === '#f5f5f5' || this.previewBackgroundColor === 'white' || this.previewBackgroundColor === 'black' || this.previewBackgroundColor === null || this.previewBackgroundColor === '')
          this.previewBackgroundColor = this.theme_color === 'dark' ? 'black' : '#f5f5f5';
      }
    );
    this.folderbreadcrumbclicked = false;
    this.breadCrumbClicked = false;
    this.remix = false;
    this.assetSuggestion = 1;
    // this.activatedRoute.params.subscribe(param=> {
    //   this.params = param.folder;
    //   if (this.params) {
    //   this.arrayParams = this.params.split('-');

    //   }
    // });
    this.resetFilterMap();
    this.httpService.currentsearchResults.subscribe(serachResults => {

      if (serachResults.filterKeys != null) {
        this.extension = serachResults.filterKeys.assetFileExtensionList;
        this.restriction = serachResults.filterKeys.productStatusList;
        this.tag = serachResults.filterKeys.tagsList;

      }

      this.resetFiltersControls();

      this.searchedResults = serachResults.search;
      this.searchResults = serachResults.search;
      this.searchKey = serachResults.searchKey;
      this.searchKeyForFilter = serachResults.searchKey ? serachResults.searchKey.trim() : serachResults.searchKey;
      this.searchInFolder = serachResults.folderid;
      if (this.searchedResults !== null) {
        this.panDisplay = "expanded";
        this.asset.relativePath = null;
      }
    });

    const token = this.userService.loggendInUser.tokens.filter(token => token.function === 'Upload');
    if (token[0]) {
      this.uploadToken = true;
    }
    this.httpService.newVersionFlag = false;
    this.httpService.asset = null;
    this.httpService.newExtensionFlag = false;
    this.httpService.updateAssetFile = false;
    this.isPersonalBrowser = false;
    this.config.changeTab(1);


    this.httpService.getBasePath().then(() => {
      this.fetchAllFilters();
      this.checkIfUserIsAdmin();
      this.getExternalApplications();
      if (this.router.url.indexOf("personal-browser") >= 0) {
        this.isPersonalBrowser = true;
        // setting the search results and search key as null when user navigates to personal browser.
        this.httpService.changesearchResults(null, null, null, null);
        this.httpService.getPersonalBrowserStructure().subscribe(
          data => {
            this.library = data;
          }, error => {
            console.log(error);
          }
        );
      } else {
        this.getRootFolder();
        // this.fetchAllFilters();
        if (this.router.url.indexOf('search/assets') < 0) {
          this.getAssetCategory();
        }

        if (this.router.url.indexOf('search/') < 0)
          this.httpService.searchAssets(this.searchKey, this.userService.loggendInUser.userEmailId, '').subscribe(
            (data: any) => {
              this.searchResults = data.searchResults;
              this.filterKeys = data.filterByValues;
              // this.library = this.searchResults.folders;
              event.target['value'] = this.searchKey;
              this.changeSearchResultSubscription = this.httpService.changesearchResults(this.searchResults, '', this.searchKey, this.filterKeys);
            },
            error => {
              this.assetsCardDetails = [];
              console.log(error);
            });
      }
    });
  }

  ngOnDestroy()
  {
    if(this.changeSearchResultSubscription)
    {
      this.changeSearchResultSubscription.unsubscribe();
    }
  }
  showFolderCategory() {
    this.httpService.changeFolderFlag(false);
  }
  hideFolder() {
    this.httpService.changeFolderFlag(true);
  }
  /**
   * Initializing filterMap when the page loads
   */
  resetFilterMap() {
    this.searchedResults = null;
    this.filterMap.set("extension", []);
    this.filterMap.set("restriction", []);
    this.filterMap.set("tag", []);
  }

  /**
   * Collapsing the accordion and clearing the filters
   */
  resetFiltersControls() {
    this.filterTagsArr = [];
    Array.from(this.filterMap.entries()).forEach(entry => {
      this.filterMap.set(entry[0], []);
    });
    this.isExtensionExpanded = false;
    this.isTagExpanded = false;
    this.isRestrictionExpanded = false;
    if (this.extensionCheckboxes != null) {
      this.extensionCheckboxes.forEach((element) => {
        element.nativeElement.active = false;
      });
    }
    if (this.restrictionCheckboxes != null) {
      this.restrictionCheckboxes.forEach((element) => {
        element.nativeElement.active = false;
      });
    }
    if (this.tagCheckboxes != null) {
      this.tagCheckboxes.forEach((element) => {
        element.nativeElement.active = false;
      });
    }
    this.selectedFoldersToSearch = '';
  }
  uncheckCheckbox() {
    this.checkedExtension = [];
    this.checkedRestrictions = [];
    this.checkedTags = [];
  }
  setTokens() {
    if (this.usertokens.has('Delete') === true) {
      this.deleteToken = true;
    }
    if (this.usertokens.has('Modify') === true) {
      this.modifyToken = true;
    }
    if (this.usertokens.has('Download') === true) {
      this.downloadToken = true;
    }
  }

  tokenManagement(token: Tokens) {
    if (this.asset.attributes && token.permissions) {
      token.permissions.forEach(permission => {

        let isPrimaryUser = false;
        let isCommerciallyReady = false;
        let hasCommercialAccess = false;

        // checing if the logged in user is uploarder or Primary contact for the selected asset.
        if (this.userService.loggendInUser.userEmailId === this.asset.attributes.uploader
          || this.userService.loggendInUser.userEmailId === this.asset.attributes.primaryContact.emailId) {
          isPrimaryUser = true;
        }

        // Checking if the asset is commercially ready.
        if (this.asset.attributes.productStatus === 1) {
          isCommerciallyReady = true;
        }

        // Checking if the user has permissions to perform opertaion on commercial assets.
        if (permission[1] === 'Commercial') {
          hasCommercialAccess = true;
        }

        if (permission[0] === 'Self' && isPrimaryUser
          && hasCommercialAccess && isCommerciallyReady) {
          this.usertokens.set(token.function, 'true');
        } else if (permission[0] === 'Self' && isPrimaryUser
          && !hasCommercialAccess && !isCommerciallyReady) {
          this.usertokens.set(token.function, 'true');
        } else if (permission[0] === 'Others' && !isPrimaryUser
          && hasCommercialAccess && isCommerciallyReady) {
          this.usertokens.set(token.function, 'true');
        } else if (permission[0] === 'Others' && !isPrimaryUser
          && !hasCommercialAccess && !isCommerciallyReady) {
          this.usertokens.set(token.function, 'true');
        }
      });
    }
  }

  getRootFolder() {
    this.httpService.getRootFolderData(this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.library = data;
        this.httpService.folder = this.library[0].subFolders[0];
        this.activatedRoute.params.subscribe(
          params => {
            this.assetIdParms = params.assetId;
            this.assetFolderParams = params.folder;

            if (this.assetIdParms) {

              this.httpService.autoLoadTree = true;
              this.selectAsset(this.assetIdParms);
            } else if (this.assetFolderParams && (sessionStorage.getItem('folderRefresh') === 'true')) {
              this.httpService.autoLoadTree = true;
              this.selectFolder();
            }
          }, err => console.log(err)
        );
      },
      error => {
        console.log(error);
      }
    );
  }

  assignAsset(asset) {
    this.asset = asset;
  }

  folderselected(event) {
    //console.log("dhfashdkasd");
    this.asset.relativePath = null;
  }

  resetValues() {
    this.attributes = {};
    this.asset.relativePath = null;
    this.formats = [];
    this.quality = [];
    this.textureQuality = [];
    this.versionList = [];
    this.selectedVersion = "";
  }

  getAssetById(id) {
    this.remix = false;
    this.assetSuggestion = 1;

    this.httpService.getAssetById(id, this.userService.loggendInUser.userEmailId).subscribe(data => {
      this.downloadAssetLevel = this.userService.loggendInUser.userSettings.userProfileType ? `Download Asset(Experienced)` : `Download Asset(Basic)`;
      this.editedAssetName = this.asset.name;
      this.editedDescription = this.asset.description;
      this.panDisplay = "collapsed";
      this.asset = data;
      this.params = data.relativePath;
      this.userService.loggendInUser.tokens.forEach(token => {
        this.tokenManagement(token);
      });
      this.setTokens();
      let uploaderEmail = JSON.parse(JSON.stringify(this.asset.attributes.uploader));
      this.Uploader = this.asset.attributes.uploader.split("@")[0];
      let supportedFiles: Array<String> = ["obj", "fbx", "stl"];

      let versionList = [];
      this.asset.assetfiles.forEach(a => {
        if (a.versionNo && versionList.indexOf(a.versionNo) <= -1)
          versionList.push(a.versionNo);
      });
      const selectedVersion = versionList[versionList.length - 1];

      let assetsInAVertion = this.asset.assetfiles.filter(
        asset => asset.versionNo === selectedVersion
      );
      this.assetFilePath = assetsInAVertion[assetsInAVertion.length - 1].filePath;

      if (supportedFiles.indexOf(this.assetFilePath.split(".")[this.assetFilePath.split(".").length - 1]) < 0) {
        let file = assetsInAVertion.find(
          a => supportedFiles.indexOf(a.specification.fileFormat.toLowerCase()) > -1
        );
        if (file) {
          this.assetFilePath = file.filePath;
        }
      }

      // this.asset.attributes.primaryContact.emailId = this.asset.attributes.primaryContact.emailId.split("@")[0];

      this.asset.assetfiles.forEach(a => {
        if (!a.deleted) {
          this.formats.push(a.specification.fileFormat);
        }
      });
      this.asset.assetfiles.forEach(a => {
        if (!a.deleted) {
          this.quality.push(a.specification.fileQuality);
        }
      });
      this.asset.assetfiles.forEach(a => {
        if (!a.deleted) {
          this.textureQuality.push(a.specification.textureQuality);
        }
      }
      );
      //Auto opening of treview is not required anymore.
      // if (this.assetIdParms && this.httpService.autoLoadTree) {
      //   this.libBrowser.constructTreeForAsset(this.asset.relativePath.split(','), null);
      // }
      // this.asset.attributes.visibility = 0;
      console.log(JSON.stringify(this.asset, null, 2));

      if (this.asset) {
        if (this.userService.loggendInUser.assetsSubscribedTo.indexOf(this.asset._id) > -1) {
          this.asset.inform = true;
        }
        let versionList = [];
        this.asset.assetfiles.forEach(a => {
          if (a.versionNo) {
            versionList.push(a.versionNo);
            if (this.versionList === undefined || this.versionList.filter(v => v.version === a.versionNo).length == 0) {
              this.versionList.push({ version: a.versionNo, deleted: false });
              const validAssets = this.asset.assetfiles.filter(asset => asset.versionNo === a.versionNo && asset.deleted === false);
              if (validAssets.length === 0) {
                this.versionList[this.versionList.length - 1].deleted = true;
              }
            }
          }
        });

        let i = this.versionList.length - 1;
        while (i >= 0) {
          if (!this.selectedVersion)
            this.selectedVersion = this.versionList[i].deleted ? this.selectedVersion : this.versionList[i].version;
          else
            break;
          i--;
        }
        this.httpService.selectedVersionNumber = this.selectedVersion;
        this.assetsInAVertion = this.asset.assetfiles.filter(
          asset => asset.versionNo === this.selectedVersion && !asset.deleted
        );
        this.selectedAsset = JSON.parse(JSON.stringify(this.assetsInAVertion[0]));
        this.filePath = this.selectedAsset.filePath;
        this.snapshotImage = this.selectedAsset.snapshotURL && this.selectedAsset.snapshotURL.length >= 1 ? this.selectedAsset.snapshotURL : [];
        this.uploadedImages = this.selectedAsset.uploadedImageURL ? this.selectedAsset.uploadedImageURL : [];
        this.previewBackgroundColor = this.selectedAsset.previewBackgroudColor === null ? this.previewBackgroundColor : this.selectedAsset.previewBackgroudColor;
        this.formatsForSelectedAssets(this.assetsInAVertion);
        this.qualityForSelectedFormat(this.selectedAsset.specification.fileFormat);
        this.experiencedMode = this.userService.loggendInUser.userSettings.userProfileType;

        // this.formats = [this.selectedAsset.specification.fileFormat];
        // this.quality = [this.selectedAsset.specification.fileQuality];
        // this.textureQuality = [this.selectedAsset.specification.textureQuality];
        this.showEdit = this.userService.loggendInUser.userEmailId.split("@")[0] === this.Uploader ||
          this.userService.loggendInUser.userEmailId === this.asset.attributes.primaryContact.emailId;
        this.httpService.assetDetails = { assetName: this.asset.name, assetId: this.asset._id, noOfRatings: this.asset.noOfRatings };
        this.httpService.selectedVersionNumber = this.selectedAsset.versionNo;
      }
      this.getParentFolderDetailsthroughRelativepath(this.asset.relativePath);
      this.fetchUploaderProfileImage(uploaderEmail);
    },
      err => {
        console.error(err);
      },
      () => {
        console.log("asset call is done");
      }
    );
  }

  selectAsset(id) {
    // console.log(id);
    if (id === "@folder") {
      this.asset = new Asset();
      return;
    }
    //storing the asset to localstorage so that the tree can be preselected if the user reload the page
    // localStorage.setItem("selectedAssetSearch",JSON.stringify(asset));
    // this.selectedAsset = asset;

    this.resetValues();
    // make http call to fetch the accets details to display it on the page
    this.getAssetById(id);
  }

  selectFolder() {
    this.httpService.getRootFolderData(this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.library = data;
        if (this.assetFolderParams && this.httpService.autoLoadTree) {
          if (this.libBrowser) {
            this.libBrowser.constructTreeForFolder(this.assetFolderParams.split('-'), this.library);
          }
        }
      });
  }

  disableContextMenu() {
    this.httpService.contextmenu = false;
  }

  search(event: KeyboardEvent) {
    this.asset.relativePath = null;
    this.searchResults = null;
    this.searchKey = event.target["value"];
    if (event.keyCode === 13) {
      if (!this.searchKey || this.searchKey.trim() === "") {
        this.reset();
        return;
      }
      // this.httpService.search(event.target["value"]).subscribe(
      //   data => {
      //     this.library = data;
      //     event.target["value"] = this.searchKey;
      //   },
      //   error => { }
      // );
      this.httpService.searchFolderAssets(event.target["value"], this.userService.loggendInUser.userEmailId).subscribe(
        data => {
          this.searchResults = data;

          this.library = this.searchResults.folders;
          event.target["value"] = this.searchKey;
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  reset() {
    this.httpService.getRootFolderData(this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.library = data;
      },
      () => { }
    );
  }

  clear(event) {
    if (event.path && event.path[0] && event.path[0].className.includes("cancel")) {
      this.reset();
    }
  }

  selectedAssetFile(assetFile: AssetFile) {
    this.assetFilePath = assetFile.filePath;
    this.loadAsset = false;

    setTimeout(() => (this.loadAsset = true));
  }

  getParentFolderDetailsthroughRelativepath(relativePath: string) {
    relativePath = relativePath.substr(0, relativePath.lastIndexOf(','));
    this.httpService.getParentFolderthroughRelativepath(relativePath).subscribe(data => {
      this.httpService.folder = data;
    }, error => {
      console.log("ParentFolder call failed");
    })
  }

  collapseFolder(folder) {
    this.libBrowser.addSubfolder(folder);
  }

  formatsForSelectedAssets(selectedAssets: Array<AssetFile>) {
    this.formats = [];
    selectedAssets.forEach(f => {
      console.log(f.specification.fileFormat);
      if (this.formats.indexOf(f.specification.fileFormat) <= -1)
        this.formats.push(f.specification.fileFormat);
    });
  }

  getLabel(label: string): string {
    if (label.toLowerCase() === "assetbundle")
      return label;
    return '.' + label;
  }

  qualityForSelectedFormat(format: String) {
    this.textureQuality = [];
    this.quality = [];
    this.assetsInFormats = this.assetsInAVertion.filter(
      asset => asset.specification.fileFormat === format && !asset.deleted
    );
    this.selectedAsset = JSON.parse(JSON.stringify(this.assetsInFormats[0]));
    //this.filePath = this.selectedAsset.filePath;
    this.assetFileSpecifaction = this.selectedAsset.specification;
    this.assetsInFormats.forEach(f => {
      if (!f.deleted) {
        this.quality.push(f.specification.fileQuality);
        this.textureQuality.push(f.specification.textureQuality);
      }
    });
  }

  selectAssetOnFileQuality(fileQuality: Number, textureQuality: Number) {
    if (
      !this.assetsInFormats.filter(
        asset =>
          asset.specification.fileQuality === fileQuality &&
          asset.specification.textureQuality === textureQuality
      )[0]
    ) {
      this.selectedAsset = JSON.parse(
        JSON.stringify(
          this.assetsInFormats.find(asset => asset.specification.fileQuality === fileQuality && !asset.deleted)
        )
      );
      //this.filePath = this.selectedAsset.filePath;
      this.assetFileSpecifaction = this.selectedAsset.specification;
    } else this.selectAssetOnQuality(fileQuality, textureQuality);
  }

  selectAssetOnTextureQuality(fileQuality: Number, textureQuality: Number) {
    if (
      !this.assetsInFormats.filter(
        asset =>
          asset.specification.fileQuality === fileQuality &&
          asset.specification.textureQuality === textureQuality
      )[0]
    ) {
      this.selectedAsset = JSON.parse(
        JSON.stringify(
          this.assetsInFormats.find(asset => asset.specification.textureQuality === textureQuality && !asset.deleted)
        )
      );
      this.assetFileSpecifaction = this.selectedAsset.specification;
    } else this.selectAssetOnQuality(fileQuality, textureQuality);
  }

  selectAssetOnQuality(fileQuality: Number, textureQuality: Number) {
    this.selectedAsset = JSON.parse(
      JSON.stringify(
        this.assetsInFormats.filter(
          asset =>
            asset.specification.fileQuality === fileQuality &&
            asset.specification.textureQuality === textureQuality
        )[0]
      )
    );
    //this.filePath = this.selectedAsset.filePath;
    this.assetFileSpecifaction = this.selectedAsset.specification;
  }

  changeVersion(version: string) {
    this.asset.avgRating = this.httpService.avgRt;
    this.loadAsset = false;
    setTimeout(() => (this.loadAsset = true));
    this.assetsInAVertion = this.asset.assetfiles.filter(asset => asset.versionNo === version);
    this.selectedAsset = JSON.parse(JSON.stringify(this.assetsInAVertion[0]));

    this.formatsForSelectedAssets(this.assetsInAVertion);
    this.qualityForSelectedFormat(this.selectedAsset.specification.fileFormat);
    // this.selectedAsset = this.asset.assetfiles.filter(a => a.versionNo === version)[0];
    let supportedFiles: Array<String> = ["obj", "fbx", "stl", "gltf", "glb"];

    let file = this.assetsInAVertion.find(
      a => supportedFiles.indexOf(a.specification.fileFormat.toLowerCase()) > -1
    );
    this.filePath = file.filePath;
    this.snapshotImage = this.selectedAsset.snapshotURL && this.selectedAsset.snapshotURL.length >= 1 ? this.selectedAsset.snapshotURL : [];
    this.uploadedImages = this.selectedAsset.uploadedImageURL ? this.selectedAsset.uploadedImageURL : [];
    this.previewBackgroundColor = this.selectedAsset.previewBackgroudColor;
    // this.formats = [this.selectedAsset.specification.fileFormat];
    // this.quality = [this.selectedAsset.specification.fileQuality];
    // this.textureQuality = [this.selectedAsset.specification.textureQuality];
    this.assetFileSpecifaction = this.selectedAsset.specification;
    this.httpService.selectedVersionNumber = version;
    this.httpService.reloadRating.next();
    // this.asset.ratings.forEach((element)=>{
    //   if(element.userEmail === this.userService.loggendInUser.userEmailId && element.assetVersion === this.httpServices.selectedVersionNumber)
    //   {
    //     this.info = element.rating;
    //   }
    //   });
  }

  inform(asset) {
    asset.inform = !asset.inform;
    this.subscribeAsset(asset.inform);
  }

  subscribeAsset(isSubscribe: boolean) {
    this.httpService
      .subscribeAsset(this.asset._id, this.asset.name, this.userService.loggendInUser.userEmailId, isSubscribe)
      .subscribe(
        () => {
          // document.getElementById('success').click();
          let assetIdIndex = this.userService.loggendInUser.assetsSubscribedTo.indexOf(
            this.asset._id
          );
          if (assetIdIndex <= -1) {
            this.userService.loggendInUser.assetsSubscribedTo.push(this.asset._id);
          } else {
            this.userService.loggendInUser.assetsSubscribedTo.splice(assetIdIndex, 1);
          }
          sessionStorage.setItem("userinfo", JSON.stringify(this.userService.loggendInUser));
          console.log("Subscribed");
        },
        err => {
          console.log(err);
        }
      );
  }

  download() {
    const assetArray = this.selectedAsset.filePath.split('\\');
    const assetLength = assetArray.length;
    this.downloadStarted = true;
    this.downloadValue = 20;
    this.httpService.downloadAssetBundle(this.selectedAsset._id, this.userService.loggendInUser.userEmailId)
      .subscribe((data: any) => {
        this.downloadValue = 70;
        let fileElement = document.createElement("a"),
          url = URL.createObjectURL(new Blob([data], { type: "application/zip" }));
        fileElement.href = url;
        fileElement.download = this.asset.name + '_' + assetArray[assetLength - 3] + '_' + assetArray[assetLength - 2];
        document.body.appendChild(fileElement);
        this.downloadValue = 90;
        fileElement.click();
        this.downloadStarted = false;
        setTimeout(function () {
          document.body.removeChild(fileElement);
          window.URL.revokeObjectURL(url);
        }, 0);
        this.httpService.addAssetDownload(this.userService.loggendInUser.userEmailId, this.asset._id).subscribe(
          data => {
            console.log(data);
          }, err => {
            console.log(err);
          }
        );
      }, err => {
        console.error(err);
        this.downloadStarted = false;
      });
  }

  validateEmailId(email: string): boolean {
    let emailValid = true;
    if (!email.endsWith("@siemens-healthineers.com")) {
      emailValid = false;
    }
    return !emailValid;
  }

  updateAsset() {
    this.asset.assetfiles.splice(
      this.asset.assetfiles.indexOf(
        this.asset.assetfiles.find(a => a._id === this.selectedAsset._id)
      ),
      1
    );

    this.asset.assetfiles.push(this.selectedAsset);
    if (this.primaryContactNameControl.valid && this.primaryContactEmailControl.valid) {
      // if(this.prodStatus !== this.asset.attributes.productStatus){
      //   this.modifyAssetStatus();
      // }
      this.httpService.updateAsset(this.asset, this.userService.loggendInUser.userEmailId, this.asset._id).subscribe(
        data => {
          this.asset = data;
          const assetIdIndex = this.userService.loggendInUser.assetsSubscribedTo.indexOf(
            this.asset._id
          );
          if (assetIdIndex <= -1) {
            this.asset.inform = false;
          } else {
            this.asset.inform = true;
          }

          this.assetFileSpecifaction = this.selectedAsset.specification;
          this.showEdit =
            this.userService.loggendInUser.userEmailId.split("@")[0] ===
            this.Uploader ||
            this.userService.loggendInUser.userEmailId ===
            this.asset.attributes.primaryContact.emailId;
          document.getElementById("my-modal").removeAttribute("visible");
          this.editDescriptionEnable = false;
        },
        err => {
          console.error(err);
        },
        () => {
          this.edit = false;
          this.fetchRemixedFromAssetAndUpdate(this.asset.remixedFrom);
        }
      );
    }
    else {
      alert("not allowed");
    }
  }

  deleteAsset() {
    document.getElementById('delete-confirmation').removeAttribute('visible');
    this.loader = true;
    this.httpService.deleteAsset(this.asset._id, this.httpService.folder._id, this.userService.loggendInUser.userEmailId).subscribe(
      () => {
        //this.router.navigateByUrl("/val-assets/search");
      }, err => {
        console.error(err);
        this.loader = false;
      }, () => {
        console.log('deleted');
        this.loader = false;
        let url = this.router.url

        //this.assetsCardDetails = this.assetsCardDetails.filter(asset => asset._id !== this.asset._id);
        this.asset.relativePath = null;
        if (url.indexOf('search') > 0) {
          this.router.navigate(['/val-assets/search']);
          //this.location.go(`/val-assets/search`);
        } else if (url.indexOf('personal-browser') > 0) {
          this.router.navigate(['/val-assets/personal-browser']);
          //this.location.go(`/val-assets/personal-browser`);
        }

        //this.collapseFolder(this.httpService.folder);
        //this.router.navigateByUrl("/val-assets/search");
      }
    );
  }

  deleteConfirmationPopUp() {
    this.validVersions = this.versionList.filter(x => x.deleted != true).length;
    document.getElementById('delete-confirmation').setAttribute('visible', 'true');
  }

  deleteAssetVersion() {
    document.getElementById('delete-confirmation').removeAttribute('visible');
    this.loader = true;
    this.httpService.deleteAssetVersion(this.asset._id, this.selectedVersion, this.userService.loggendInUser.userEmailId).subscribe(
      (data: any) => {
        this.loader = false;
        this.versionList.find(x => x.version == this.selectedVersion).deleted = true;
        let i = this.versionList.length - 1;
        this.selectedVersion = null;
        while (i >= 0) {
          if (!this.selectedVersion)
            this.selectedVersion = this.versionList[i].deleted ? this.selectedVersion : this.versionList[i].version;
          else {
            this.changeVersion(this.selectedVersion);
            break;
          }
          i--;
        }
        this.assetInfo.loadAsset = !this.assetInfo.loadAsset;
        this.httpService.assetDetails.avgRt = data[1];
        this.httpService.count = data[0];
        this.starRate.rating = data[1];
        this.httpService.avgRt = data[1];
      },
      () => {
        this.loader = false;
      }
    );
  }

  cancelEdit() {
    this.asset = this.uneditedAsset;
    this.selectedAsset = this.unEditedAssetFile;
    this.assetFileSpecifaction = this.selectedAsset.specification;
    this.uneditedAssetEmit.emit(this.asset);
    this.edit = false;
  }

  modifyAsset() {
    this.uneditedAsset = JSON.parse(JSON.stringify(this.asset));
    this.unEditedAssetFile = JSON.parse(JSON.stringify(this.selectedAsset));
    this.primaryContactNameControl.setValue(this.asset.attributes.primaryContact.name);
    this.primaryContactEmailControl.setValue(this.asset.attributes.primaryContact.emailId);
  }

  changeCheckBoxValue(obj, param) {
    setTimeout(() => {
      obj[param] = !obj[param];
    });
  }

  newVersion() {
    this.httpService.currentSearchPath.subscribe(path => {
      this.params = path;
    });
    if (!this.params) {
      this.activatedRoute.params.subscribe(param => {
        this.params = param.folder;
      });
    }
    this.httpService.newVersionFlag = true;
    this.httpService.asset = this.asset;
    this.router.navigateByUrl(`/val-assets/upload-assets/${this.params}`);
  }

  newExtension() {
    this.httpService.currentSearchPath.subscribe(path => {
      this.params = path;
    });
    if (!this.params) {
      this.activatedRoute.params.subscribe(param => {
        this.params = param.folder;
      });
    }
    this.httpService.newExtensionFlag = true;
    this.httpService.asset = this.asset;
    this.router.navigateByUrl(`/val-assets/upload-assets/${this.params}`);
  }

  updateAssetFile() {
    this.httpService.currentSearchPath.subscribe(path => {
      this.params = path;
    });
    if (!this.params) {
      this.activatedRoute.params.subscribe(param => {
        this.params = param.folder;
      });
    }
    this.httpService.updateAssetFile = true;
    this.httpService.asset = this.asset;
    this.httpService.selectedAssetFile = this.selectedAsset;
    this.router.navigateByUrl(`/val-assets/upload-assets/${this.params}`);
  }

  searchTag(searchKey: string) {
    this.searchKey = searchKey;
    this.httpService.searchFolderAssets(searchKey, this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.searchResults = data;
        event.target["value"] = this.searchKey;
      },
      error => {
        console.log(error);
      }
    );
  }

  advanceFilterData() {
    console.log(this.radioGroupValue, this.customFileSize);
    console.log(this.dateModified, this.customModifiedDate);
    console.log(this.datePublished, this.customPublishedDate);
    console.log("Today : ", new Date().toLocaleDateString());
    this.getLastWeek();
  }

  getLastWeek() {
    let curr = new Date();
    var firstday = new Date(curr.setDate((curr.getDate() - 7) - curr.getDay()));
    var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
    console.log("Last Week : ", firstday.toLocaleDateString() + '-' + lastday.toLocaleDateString());
  }

  clearAdvanceFilter() {
    this.radioGroupValue = 0;
    this.customFileSize = 0;
  }

  /**
   *
   * @param libBrowserObj - this object will take the parent folderId and the section (search the lib / personal browser)
   */
  fetchCardDetails(libBrowserObj: { folderId: any, section: string, libId: any }) {
    /* Resetting the filter map when a new filter is applied*/
    Array.from(this.filterMap.entries()).forEach(entry => {
      this.filterMap.set(entry[0], []);
    });

    this.assetsCardDetails = [];
    this.extension = [];
    this.restriction = [];
    this.tag = [];
    this.filterTagsArr = [];
    /*--------- */

    /* If user is in Search the lib section get the filter data from the search api */
    if (libBrowserObj.section === 'searchLib') {
      this.parentFolderId = libBrowserObj.folderId;
      /* First parameter =  the search key as ' '*/
      this.httpService.searchAssets(' ', this.userService.loggendInUser.userEmailId, libBrowserObj.folderId).subscribe(
        (response: any) => {
          /**Populating the 3 filters array and the assetcarddetail*/
          this.assetsCardDetails = response.searchResults.assets;
          this.extension = response.filterByValues.assetFileExtensionList;
          this.restriction = response.filterByValues.productStatusList;
          this.tag = response.filterByValues.tagsList;
        },
        (err) => {
          console.log(err);
          this.assetsCardDetails = [];
        });
    }
    /* If user is in library browser get the filter data from the getAssetCardDetails api */
    else if (libBrowserObj.section === 'personalBrowser') {
      this.resetAllFolderDetails();
      this.parentFolderId = libBrowserObj.libId;
      if (libBrowserObj.folderId && libBrowserObj.folderId.length > 0) {
        /**First paramter=array of all folderid's */
        this.httpService.getAssetCardDetails(libBrowserObj.folderId, this.userService.loggendInUser.userEmailId).subscribe(
          (response: any) => {
            /**Populating the 3 filters array and the assetcarddetail*/
            this.assetsCardDetails = response.assetCardDetails;
            this.extension = response.filterByValues.assetFileExtensionList;
            this.restriction = response.filterByValues.productStatusList;
            this.tag = response.filterByValues.tagsList;
          }, err => {
            console.log(err);
          }, () => {
            console.log("Done");
          }
        );
      }
    }
  }

  /**
   *
   * @param selectedItem - the selected checkbox
   * @param filterType - filter category
   */
  filterSelected(selectedItem, filterType) {

    let tempArr = [];
    let tempFilterTagsArr = [];
    tempArr = this.filterMap.get(filterType);
    if (filterType == "restriction") {
      if (tempArr.includes(this.resrtictionType[selectedItem])) {
        tempArr.splice(tempArr.indexOf(this.resrtictionType[selectedItem]), 1);
      }
      else {
        tempArr.push(selectedItem);
      }
    }
    else {
      if (tempArr.includes(selectedItem)) {
        tempArr.splice(tempArr.indexOf(selectedItem), 1);
      }
      else {
        tempArr.push(selectedItem);
      }
    }

    this.filterMap.set(filterType, tempArr);
    // Updating the filter map array as per the new filter data
    Array.from(this.filterMap.entries()).forEach(entry => {
      let tempValue = entry[1];
      if (entry[0] === 'restriction') {
        let first = tempValue.findIndex(x => x == "0");
        let second = tempValue.findIndex(x => x == "1");
        let third = tempValue.findIndex(x => x == "2");
        if (first > -1) {
          tempValue[first] = 'Not Commercially Ready';
        }
        else if (second > -1) {
          tempValue[second] = 'Commercially Ready';
        }
        else if (third > -1) {
          tempValue[third] = 'Product is Development';
        }
      }
      tempFilterTagsArr = tempFilterTagsArr.concat(tempValue);
    });
    this.filterTagsArr = tempFilterTagsArr;
  }

  extensionAccordianOpen() {
    setTimeout(() => {
      this.isExtensionExpanded = true;
    });
  }

  restrictionAccordianOpen() {
    setTimeout(() => {
      this.isRestrictionExpanded = true;
    });
  }

  tagAccordianOpen() {
    setTimeout(() => {
      this.isTagExpanded = true;
    });
  }

  /**
   * calling the filter post API
   */
  applyFilters() {
    return new Promise((resolve, reject) => {
      let tmpMap = new Map();
      let arr = JSON.parse(JSON.stringify(Array.from(this.filterMap.entries())));
      arr.forEach(element => {
        tmpMap.set(element[0], element[1]);
      });
      if (tmpMap.get("restriction").length > 0) {
        let arr = tmpMap.get("restriction");
        for (let i = 0; i < arr.length; i++) {
          arr[i] = this.resrtictionType.findIndex(x => x == arr[i]);
        }
      }
      this.isExtensionExpanded = false;
      this.isRestrictionExpanded = false;
      this.isTagExpanded = false;
      this.filterSelectionValues = {};
      this.filterSelectionValues = {
        "assetFileExtensionList": tmpMap.get('extension'),
        "polygonCountList": [],
        "productStatusList": tmpMap.get('restriction'),
        "tagsList": tmpMap.get('tag'),
        "advanceList": []
      };
      let folderId: any;
      if (!this.searchInFolder) {
        folderId = this.parentFolderId;
      }
      else {
        folderId = this.searchInFolder;
      }
      this.filterList = tmpMap;
      /**Calling the filter api */
      // this.httpService.applyFilters(this.searchKeyForFilter === '' || !this.searchKeyForFilter
      //   ? ' ' : this.searchKeyForFilter, this.userService.loggendInUser.userEmailId,
      //   folderId === '' || !folderId ? '' : folderId, this.filterSelectionValues)
      //   .subscribe(
      //     (response: any) => {
      //       this.assetsCardDetails = response.searchResults.assets;
      //       if (!this.searchResults) {
      //         this.searchResults = {};
      //       }
      //       this.searchResults.assets = response.searchResults.assets;
      //       resolve();
      //     },
      //     (err) => {
      //       this.assetsCardDetails = [];
      //       this.searchResults = {};
      //       this.failureNotification("Assets with the selected filters are not present.");
      //       // this.clearFilter();
      //       this.filterList.clear();
      //       this.sortKey = -1;
      //       reject(err);
      //     }
      //   );
      this.httpService.applyFilters(this.searchKeyForFilter === '' || !this.searchKeyForFilter
        ? ' ' : this.searchKeyForFilter, this.userService.loggendInUser.userEmailId, folderId !== '' ? folderId : this.selectedFoldersToSearch, this.filterSelectionValues).subscribe(
          (response: any) => {
            this.assetsCardDetails = response.searchResults.assets;
            if (!this.searchResults) {
              this.searchResults = {};
            }
            this.searchResults.assets = response.searchResults.assets;
            if (this.isDisplayTags === true) {
              let toPathArray = new Set<string>();
              this.searchResults.assets.forEach(element => {
                let pathArray = [];
                pathArray = element.relativePath.split(',');
                for (var i = 0; i < pathArray.length - 1; i++) {
                  toPathArray.add(pathArray[i]);
                }
              });
              this.filterTagsArr = this.filterTagsArr.concat(Array.from(toPathArray));
              this.isDisplayTags = false;
            }
            resolve(response);
          },
          (err) => {
            this.assetsCardDetails = [];
            this.searchResults = {};
            this.failureNotification("Assets with the selected filters are not present.");
            this.filterList.clear();
            this.sortKey = 0;
            reject(err);
          }
        );
    })
  }

  filterListElements(): boolean {
    let flag = true;
    Array.from(this.filterList.entries()).forEach(item => {
      if (item[1].length > 0)
        flag = false;
    });
    return flag;
  }


  saveFilters(val) {
    this.maxFilter = false;
    let dict = {};
    let tmpArr: Array<any> = Array.from(this.filterList.entries());
    tmpArr.forEach(x => {
      dict[x[0]] = x[1];
    });
    dict["sortKey"] = this.sortKey;

    if (dict["restriction"] !== null) {
      let restArr = [];
      dict["restriction"].forEach(it => {
        restArr.push(it.toString());
      });
      dict["restriction"] = restArr;
    }

    let mongoDoc: CustomFilter = new CustomFilter();
    mongoDoc.customTag = val;
    let cat: Category = new Category();
    cat.extension = dict["extension"];
    cat.restriction = dict["restriction"];
    cat.tag = dict["tag"];
    cat.sortKey = dict["sortKey"];
    cat.BusinessCategory = this.selectedFoldersToSearch;
    mongoDoc.filters = cat;

    if (!this.checkMaxFilterCount() && !this.checkNameExists(val) && !this.checkSelectedFilters(JSON.parse(JSON.stringify(mongoDoc)))) {
      this.targ = "";
      this.httpService.saveFilters(mongoDoc, this.userService.loggendInUser._id).subscribe((result) => {
        this.successNotification("Filter saved");
        this.personalFilter = JSON.parse(JSON.stringify(result));
        this.filterList.clear();
        this.filterNameControl.setValue("");
        this.targ = "";
      }, (err) => {
        this.failureNotification("Error Encountered");
      });
    }
    else {
      let message = "";

      if (this.checkMaxFilterCount() && !this.checkNameExists(val)) {
        message = "Maximum filters that can be saved is 8.";
        this.maxFilter = true;
      }
      if (!this.checkMaxFilterCount() && this.checkNameExists(val)) {
        message = "Filter name already exists";
      }
      if (this.checkSelectedFilters(mongoDoc)) {
        message = "Filter with similar options already saved";
      }
      this.failureNotification(message);
      // this.filterList.clear();
      this.filterNameControl.setValue("");
      this.targ = "";
    }
  }

  actionEvent(event, personal) {
    event.stopPropagation();
    this.tempFilter = JSON.parse(JSON.stringify(personal));
  }

  renameFilter(item) {
    let prevName = this.tempFilter.customTag;
    this.tempFilter.customTag = item;
    if (!this.checkNameExists(item)) {
      this.httpService.renameFilter(prevName, this.userService.loggendInUser._id, this.tempFilter).subscribe((result) => {
        this.successNotification(result);
        this.fetchAllFilters();
        this.filterNameControl.setValue("");
        this.targ = "";
      }, (err) => {
        this.failureNotification(err.error);
        this.filterNameControl.setValue("");
        this.targ = "";
      });
    }
    else {
      this.failureNotification("Filter name should be unique");
      this.filterNameControl.setValue("");
      this.targ = "";
    }
  }

  deleteFilter() {
    this.httpService.deleteFilter(this.tempFilter.customTag, this.userService.loggendInUser._id).subscribe((result) => {
      this.successNotification(result);
      this.fetchAllFilters();
    }, (err) => {
      this.failureNotification("Error Deleting");
    });
  }

  successNotification(message) {
    this.showSuccess = true;
    this.showSuccessMessage = message;
    setTimeout(() => {
      this.showSuccess = false;
    }, 5000);
  }

  failureNotification(message) {
    this.showFailure = true;
    this.showFailureMessage = message;
    setTimeout(() => {
      this.showFailure = false;
    }, 5000);
  }

  checkMaxFilterCount(): boolean {
    if (this.personalFilter === undefined) {
      return false;
    }
    if (this.personalFilter.customUserFilters.length == 8) {
      return true;
    }
    return false;
  }

  checkSelectedFilters(doc): boolean {
    let flag = false;
    if (this.personalFilter === undefined) {
      return flag;
    }
    this.personalFilter.customUserFilters.forEach(item => {
      if (JSON.stringify(doc.filters) === JSON.stringify(item.filters))
        flag = true;
    });
    return flag;
  }

  checkNameExists(val: string): boolean {
    val = val.trim();
    if (this.personalFilter === undefined) {
      return false;
    }
    let tempFilter = this.personalFilter.customUserFilters.filter(el => {
      return el.customTag.toLowerCase() === val.toLowerCase();
    });
    if (tempFilter.length > 0) {
      return true;
    }
    return false;
  }

  fetchAllFilters() {
    this.httpService.fetchFilters(this.userService.loggendInUser._id);
    this.httpService.populateAllFilters().subscribe((res) => {
      this.personalFilter = res;
    }, (err) => {
      this.failureNotification("No saved Filters found");
      this.uncheckCheckbox();
    });
  }

  emitOverlayDetailsAsset() {
    this.emitOverlayDetailsAssetShow = true;
  }

  /**
   * To validate the asset name
   * @param str - asset name
   */
  assetNameValidation(str: string) {
    //The asset name must be alphanumeric with _ and - allowed.It should not end with _ and -
    if (this.assetNameRegExp.test(str) &&
      (!str.endsWith('-') && !str.endsWith('_')) &&
      (str.slice(0, 1) !== '_' && str.slice(0, 1) !== '-')) {
      this.assetNameValidFlg = true;
    } else {
      this.assetNameValidFlg = false;
    }
  }

  editDescription() {
    this.asset.description = this.editedDescription;
    this.modifyAsset();
    this.updateAsset();
  }

  renameAsset() {
    this.assetNameValidation(this.editedAssetName);
    this.assetNameError = false;
    this.assetNameExists = false;
    this.httpService.getFolderById(this.httpService.folder._id).subscribe(data => {
      this.httpService.folder = data;
      if (this.editedAssetName.length == 0) {
        this.assetNameError = true;
      }
      else if (this.assetNameValidFlg === false) {
        return;
      }

      else if (this.httpService.folder.assetList.filter(asset => asset.name.toLowerCase() === this.editedAssetName.toLowerCase()).length > 0) {
        this.assetNameExists = true;
      } else {
        this.loader = true;
        //put call for renaming asset
        this.httpService.renameAsset(this.editedAssetName.trim(), this.asset._id, this.httpService.folder._id, this.userService.loggendInUser.userEmailId).subscribe(
          (data: Asset) => {
            let assetTree = this.httpService.folder.assetList.find((asset: Asset) => asset.name.toLowerCase() === this.asset.name.toLowerCase());
            assetTree.name = this.editedAssetName;
            this.asset = data;
            if (this.asset) {
              if (this.userService.loggendInUser.assetsSubscribedTo.indexOf(this.asset._id) > -1) {
                this.asset.inform = true;
              }
            }
            // this.assetPath = this.asset.relativePath;
          }, err => {
            console.log(err);
            this.loader = false;
          }, () => {
            if (this.asset.remixedFrom !== null) {
              this.fetchRemixedFromAsset(this.asset.remixedFrom);
            }
            this.loader = false;
            this.renameEnable = false;
          }
        )
      }
    });

  }

  fetchRemixedFromAsset(id) {
    let asset: Asset;
    this.httpService.getAssetById(id, this.userService.loggendInUser.userEmailId).subscribe(res => {
      asset = res;
      let newName = JSON.parse(JSON.stringify(this.asset.name));
      asset.remixes.find(x => x._id == this.asset._id).assetName = newName;
    }, err => {
      console.log(err);
    },
      () => {
        this.modifyParentAsset(asset);
      });
  }

  fetchRemixedFromAssetAndUpdate(id) {
    let asset: Asset;
    this.httpService.getAssetById(id, this.userService.loggendInUser.userEmailId).subscribe(res => {
      asset = res;
      let newVisibility = JSON.parse(JSON.stringify(this.asset.attributes.visibility));
      asset.remixes.find(x => x._id == this.asset._id).visibility = newVisibility;
      let newPrimaryContact = JSON.parse(JSON.stringify(this.asset.attributes.primaryContact.name));
      asset.remixes.find(x => x._id == this.asset._id).primaryContactName = newPrimaryContact;
    }, err => {
      console.log(err);
    },
      () => {
        this.modifyParentAsset(asset);
      });
  }

  modifyParentAsset(asset) {
    this.httpService.updateAsset(asset, this.userService.loggendInUser.userEmailId, asset._id).subscribe(res => {
      console.log("parent Asset details modified");
    }, err => {
      console.log(err);
    });
  }

  assetRelativePathRecive(path) {
    // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", path);
    if (this.searchedResults !== null) {
      this.asset.relativePath = null;
    } else {
      this.asset.relativePath = path + `,${this.asset.name}`;
    }
  }

  setPolygonCount(event) {
    this.selectedAsset.specification.polygonCount = event;
  }

  sortAssets(sortBy: SortAssetsBy) {
    let filterParamForSort: any;
    /**Deciding if any sort is being done on some filtered data or normal data */
    if (this.filterTagsArr.length === 0) {
      filterParamForSort = {};
    }
    else {
      filterParamForSort = this.filterSelectionValues;
    }
    this.searchResults = null;
    this.searchInFolder = !this.searchInFolder ? this.parentFolderId : this.searchInFolder;
    this.sortKey = sortBy;

    //Calling the sort api
    this.httpService.sortAssets(this.searchKeyForFilter, this.userService.loggendInUser.userEmailId, sortBy, this.searchInFolder, filterParamForSort).subscribe(
      (data: any) => {
        this.searchResults = data.searchResults;
        // this.library = this.searchResults.folders;
        event.target["value"] = this.searchKey;
      },
      error => {
        console.log(error);
      }
    );
  }

  navigateToProfile() {
    this.httpService.uploader = this.asset.attributes.uploader;
    this.router.navigate(['/val-assets/userProfile', this.asset.attributes.primaryContact.emailId]);
  }

  pathUrl(path: any) {
    this.parameter = '';
    this.breadCrumbClicked = true;
    this.httpService.folder2ndround = false;
    this.httpService.folderRefresh = true;
    this.httpService.autoLoadTree = true;
    sessionStorage.setItem('folderRefresh', 'true');
    let paramArr = [];
    // this.activatedRoute.params.subscribe(param=>{
    //   this.params = param.folder;
    // })
    paramArr = this.params.split(',');
    for (const param of paramArr) {
      if (param === path) {
        this.parameter = (this.parameter !== '' ? this.parameter + '-' : '') + param;
        break;
      } else {
        this.parameter = (this.parameter !== '' ? this.parameter + '-' : '') + param;
      }
    }
    this.router.navigateByUrl(`val-assets/search/folders/${this.parameter}`);
  }

  pathUrlFOlder(folderbreadcrump) {
    this.httpService.folder2ndround = false;
    this.httpService.folderRefresh = true;
    this.folderbreadcrumbclicked = true;
    this.httpService.autoLoadTree = true;
    let paramArr = [];
    this.parameter = '';

    paramArr = this.params.split('-');
    for (const param of paramArr) {
      if (param === folderbreadcrump) {
        this.parameter = (this.parameter !== '' ? this.parameter + '-' : '') + param;
        break;
      } else {
        this.parameter = (this.parameter !== '' ? this.parameter + '-' : '') + param;
      }
    }
    this.router.navigateByUrl(`val-assets/search/folders/${this.parameter}`);
    this.selectFolder();
  }

  parameterUrl(event: any) {
    this.params = event;
    this.arrayParams = this.params.split('-');
  }

  getAssetCategory() {
    this.showFolderStructure();
  }

  getDefaultSearchResults() {
    this.httpService.searchAssets(' ', this.userService.loggendInUser.userEmailId, '').subscribe(
      (data: any) => {
        this.searchResults = data.searchResults;
        this.filterKeys = data.filterByValues;
        // this.library = this.searchResults.folders;
        event.target['value'] = this.searchKey;
        this.httpService.changesearchResults(this.searchResults, '', '', this.filterKeys);
      },
      error => {
        this.assetsCardDetails = [];
        console.log(error);
      });
  }

  resetAllFolderDetails() {
    this.isConfigurationVisible = false;
    this.selectedBusinessFolders = [];
    this.selectedProductFamilyFolders = [];
    this.selectedProductFolders = [];
    this.selectedConfigurationFolders = [];

    this.businessStructure = [];
    this.product = [];
    this.productFamily = [];
    this.configurationFolders = [];

    this.masterBusinessStructure = [];
    this.masterProduct = [];
    this.masterProductFamily = [];
    this.masterConfiguration = [];
  }

  setUpFolderStructure() {
    this.folderStructure.forEach(folder => {
      folder.parent = new FolderStructure();
      folder.parent._id = "root";
      this.businessStructure.push(folder);
      this.masterBusinessStructure.push(folder);
      if (folder.subFolders) {
        folder.subFolders.forEach(subFolder => {
          subFolder.parent = folder;
          this.productFamily.push(subFolder);
          this.masterProductFamily.push(subFolder);
          if (subFolder.subFolders) {
            subFolder.subFolders.forEach(lastFolder => {
              lastFolder.parent = subFolder;
              this.product.push(lastFolder);
              this.masterProduct.push(lastFolder);
              if (lastFolder.subFolders) {
                lastFolder.subFolders.forEach(lastSubFolder => {
                  lastSubFolder.parent = lastFolder;
                  this.masterConfiguration.push(lastSubFolder);
                });
              }
            });
          }
        });
      }
    });
  }

  showFolderStructure() {
    this.resetAllFolderDetails();
    this.httpService.getAllFolders(this.userService.loggendInUser.userEmailId).subscribe(response => {
      this.folderStructure = response;
      this.setUpFolderStructure();
    });
  }

  selectBusinessCategory(businessfolder: FolderStructure) {
    this.arrayParams = [];
    if (businessfolder.selected == undefined) {
      businessfolder.selected = false;
      this.isConfigurationVisible = false;
    }
    businessfolder.selected = !businessfolder.selected;
    if (this.selectedBusinessFolders.length === 0) {
      this.productFamily = [];
      this.product = [];
      this.configurationFolders = [];
    }
    if (businessfolder.selected) {
      this.folderStructure.forEach(folder => {
        if (folder._id === businessfolder._id) {
          if (this.selectedBusinessFolders.indexOf(businessfolder) === -1) {
            this.selectedBusinessFolders.push(businessfolder);
          }
          if (this.businessStructure.indexOf(folder) === -1) {
            this.businessStructure.push(folder);
          }
          if (folder.subFolders) {
            folder.subFolders.forEach(subFolder => {
              if (this.productFamily.indexOf(subFolder) === -1) {
                this.productFamily.push(subFolder);
              }
              if (subFolder.subFolders) {
                subFolder.subFolders.forEach(lastFolder => {
                  if (this.product.indexOf(lastFolder) === -1) {
                    this.product.push(lastFolder);
                  }
                });
              }
            });
          }
        }
      });
      this.selectedBusinessFolders = this.selectedBusinessFolders.filter(bf => bf.selected == true);
      this.onBusinessStructureChange();
      this.searchAssetsthroughFolder();
    } else if (!businessfolder.selected && this.selectedBusinessFolders.length > 1) {
      for (let i = this.businessStructure.length - 1; i >= 0; i--) {
        if (this.businessStructure[i]._id === businessfolder._id) {
          for (let j = this.productFamily.length - 1; j >= 0; j--) {
            if (this.productFamily[j].parent._id === this.businessStructure[i]._id) {
              for (let k = this.product.length - 1; k >= 0; k--) {
                if (this.product[k].parent._id === this.productFamily[j]._id) {
                  this.product.splice(k, 1);
                }
              }
              this.productFamily.splice(j, 1);
            }
          }
          this.selectedBusinessFolders.splice(i, 1);
        }
      }
      this.selectedBusinessFolders = this.selectedBusinessFolders.filter(bf => bf.selected == true);
      this.onBusinessStructureChange();
      this.searchAssetsthroughFolder();
    }
    else if (!businessfolder.selected && this.selectedBusinessFolders.length === 1) {
      this.selectedBusinessFolders = this.selectedBusinessFolders.filter(bf => bf._id != businessfolder._id);
      this.onBusinessStructureChange();
      this.searchAssetsthroughFolder();
    }
    // else if (!businessfolder.selected && this.selectedBusinessFolders.length === 1) {
    //   // this.showFolderStructure();
    //   this.resetAllFolderDetails();
    //   this.setUpFolderStructure();
    // }
  }

  selectProductFamily(item: FolderStructure) {
    this.arrayParams = [];
    if (this.selectedProductFamilyFolders.length === 0) {
      this.businessStructure = [];
      this.product = [];
      this.configurationFolders = [];
      this.isConfigurationVisible = false;
    }
    if (item.selected == undefined) {
      item.selected = false;
    }
    item.selected = !item.selected;
    if (item.selected) {
      this.productFamily.forEach(pr => {
        if (pr._id === item._id) {
          this.folderStructure.forEach(product => {
            if (product._id === pr.parent._id) {
              this.selectedProductFamilyFolders.push(item);
              if (this.businessStructure.indexOf(product) === -1) {
                this.businessStructure.push(product);
              }
              if (pr.subFolders) {
                pr.subFolders.forEach(sub => {
                  if (this.product.indexOf(sub) === -1) {
                    this.product.push(sub);
                  }
                });
              }
            }
          });
        }
      });
    }
    else if (!item.selected && this.selectedProductFamilyFolders.length > 1) {
      //     })} else if (!businessfolder.selected) {
      for (let i = this.businessStructure.length - 1; i >= 0; i--) {
        if (this.businessStructure[i]._id === item.parent._id) {
          for (let j = this.productFamily.length - 1; j >= 0; j--) {
            if (this.productFamily[j]._id === item._id) {
              for (let k = this.product.length - 1; k >= 0; k--) {
                if (this.product[k].parent._id === this.productFamily[j]._id) {
                  this.product.splice(k, 1);
                }
              }
              this.selectedProductFamilyFolders.splice(j, 1);
            }
          }
        }
      }
    }
    this.selectedProductFamilyFolders = this.selectedProductFamilyFolders.filter(pdt => pdt.selected == true);
    this.onProductFamilyChange();
    this.searchAssetsthroughFolder();
  }

  selectProduct(item) {
    this.arrayParams = [];
    if (item.selected == undefined) {
      item.selected = false;
    }
    if (this.selectedProductFolders.length === 0) {
      this.businessStructure = [];
      this.productFamily = [];
      this.configurationFolders = [];
    }
    item.selected = !item.selected;
    if (item.selected) {
      this.product.forEach(pr => {
        if (pr._id === item._id) {
          if (pr.subFolders && pr.selected) {
            this.isConfigurationVisible = true;
            pr.subFolders.forEach(subFolder => {
              this.configurationFolders.push(subFolder);
            });

          }
          this.folderStructure.forEach(product => {
            product.subFolders.forEach(sub => {
              if (sub._id === pr.parent._id) {
                this.selectedProductFolders.push(item);
                if (this.productFamily.indexOf(sub) === -1) {
                  this.productFamily.push(sub);
                }
                if (sub.parent._id === product._id) {
                  if (this.businessStructure.indexOf(product) === -1) {
                    this.businessStructure.push(product);
                  }
                }
              }
            });
          });
        }
      });
    } else if (!item.selected && this.selectedProductFolders.length > 0) {
      //     })} else if (!businessfolder.selected) {
      if (this.selectedProductFolders.length === 1) {
        this.isConfigurationVisible = false;
      }
      for (let j = this.productFamily.length - 1; j >= 0; j--) {
        if (this.productFamily[j]._id === item.parent._id) {
          for (let k = this.product.length - 1; k >= 0; k--) {
            if (this.product[k]._id === item._id) {
              for (let i = this.configurationFolders.length - 1; i >= 0; i--) {
                if (this.configurationFolders[i].parent._id === item._id) {
                  this.configurationFolders.splice(i, 1);
                }
              }

              this.selectedProductFamilyFolders.splice(j, 1);
            }
          }
        }

      }
    }
    this.selectedProductFolders = this.selectedProductFolders.filter(pdt => pdt.selected == true);
    this.onProductChange();
    this.searchAssetsthroughFolder();
  }

  selectConfiguration(item) {
    this.arrayParams = [];
    if (this.selectedConfigurationFolders.length === 0) {
      this.businessStructure = [];
      this.productFamily = [];
      this.product = [];
    }
    if (item.selected == undefined) {
      item.selected = false;
    }
    item.selected = !item.selected;
    if (item.selected) {
      this.configurationFolders.forEach(pr => {
        if (pr._id === item._id) {
          this.selectedConfigurationFolders.push(item);
          this.folderStructure.forEach(product => {
            product.subFolders.forEach(sub => {
              sub.subFolders.forEach(subFolder => {
                if (subFolder._id === pr.parent._id) {
                  if (this.product.indexOf(subFolder) === -1) {
                    this.product.push(subFolder);
                  }
                  if (subFolder.parent._id === sub._id) {
                    if (this.productFamily.indexOf(sub) === -1) {
                      this.productFamily.push(sub);
                      if (this.businessStructure.indexOf(sub.parent) === -1) {
                        this.businessStructure.push(sub.parent);
                      }
                    }
                  }
                }
              });

            });
          });
        }
      });
    }
    this.selectedConfigurationFolders = this.selectedConfigurationFolders.filter(pdt => pdt.selected == true);
    this.onConfigurationChange();
    this.searchAssetsthroughFolder();
  }

  onBusinessStructureChange() {
    if (this.selectedProductFolders.length == 0 && this.selectedProductFamilyFolders.length == 0 && this.selectedBusinessFolders.length == 0) {
      this.resetAllFolderDetails();
      this.setUpFolderStructure();
      return;
    }
    if (this.selectedBusinessFolders.length != 0) {
      this.productFamily = [];
      this.product = [];
      this.folderStructure.forEach(businessFolder => {
        if (this.selectedBusinessFolders.find(x => x._id == businessFolder._id)) {
          if (businessFolder.subFolders) {
            if (this.selectedProductFamilyFolders.length == 0 && this.selectedProductFolders.length == 0) {
              businessFolder.subFolders.forEach(pdtFamFolder => {
                if (!this.productFamily.some(pf => businessFolder.subFolders.includes(pf))) {
                  this.productFamily = this.productFamily.concat(businessFolder.subFolders);
                }
                this.product = this.product.concat(pdtFamFolder.subFolders);
              });
            } else {
              if (this.selectedProductFamilyFolders.length != 0) {
                this.productFamily = this.masterProductFamily.filter(pf => this.selectedBusinessFolders.includes(pf.parent));
                this.product = this.masterProduct.filter(pf => this.selectedProductFamilyFolders.includes(pf.parent));
                return;
              }
              if (this.selectedProductFolders.length != 0) {
                // filter products based on business structure
                this.selectedBusinessFolders.forEach(sbf => {
                  if (sbf.subFolders) {
                    sbf.subFolders.forEach(pf => {
                      this.product = this.product.concat(pf.subFolders);
                    });
                  }
                });
                this.productFamily = this.masterProductFamily.filter(pf => this.selectedBusinessFolders.includes(pf.parent));
                return;
              }
            }
          }
        }
      });
    }
  }

  onProductFamilyChange() {
    if (this.selectedProductFolders.length == 0 && this.selectedProductFamilyFolders.length == 0 && this.selectedBusinessFolders.length == 0) {
      this.resetAllFolderDetails();
      this.setUpFolderStructure();
      return;
    }
    if (this.selectedProductFamilyFolders.length != 0) {
      this.businessStructure = [];
      this.product = [];
      this.folderStructure.forEach(businessFolder => {
        if (businessFolder.subFolders) {
          businessFolder.subFolders.forEach(pdtFamFolder => {
            if (this.selectedProductFamilyFolders.find(x => x._id == pdtFamFolder._id)) {
              if (businessFolder.subFolders && this.selectedProductFamilyFolders.some(pf => businessFolder.subFolders.includes(pf))) {
                this.product = this.product.concat(pdtFamFolder.subFolders);
                if (!this.businessStructure.find(x => x._id == businessFolder._id)) {
                  this.businessStructure.push(businessFolder);
                }
              }
            }
          });
        }
      });
    } else {
      if (this.selectedBusinessFolders.length != 0) {
        if (this.selectedProductFolders.length != 0) {
          this.productFamily = this.masterProductFamily.filter(pf => pf.subFolders.some(pdt => this.product.includes(pdt)));
          this.businessStructure = this.masterBusinessStructure.filter(bs => bs.subFolders.some(pf => this.productFamily.includes(pf)));
        } else {
          this.productFamily = this.masterProductFamily.filter(pf => this.businessStructure.includes(pf.parent));
          this.product = this.masterProduct.filter(pf => this.productFamily.includes(pf.parent));
        }
      } else {
        this.productFamily = this.masterProductFamily.filter(pf => pf.subFolders.some(pdt => this.product.includes(pdt)));
        this.businessStructure = this.masterBusinessStructure.filter(bs => bs.subFolders.some(pf => this.productFamily.includes(pf)));
      }
    }
  }

  onProductChange() {
    if (this.selectedProductFolders.length == 0 && this.selectedProductFamilyFolders.length == 0 && this.selectedBusinessFolders.length == 0) {
      this.resetAllFolderDetails();
      this.setUpFolderStructure();
      return;
    }
    if (this.selectedProductFolders.length != 0) {
      this.businessStructure = [];
      this.productFamily = [];
      this.folderStructure.forEach(businessFolder => {
        if (businessFolder.subFolders) {
          businessFolder.subFolders.forEach(pdtFamFolder => {
            if (pdtFamFolder.subFolders && this.selectedProductFolders.some(pdt => pdtFamFolder.subFolders.includes(pdt))) {
              this.productFamily.push(pdtFamFolder);
              if (!this.businessStructure.find(x => x._id == businessFolder._id)) {
                this.businessStructure.push(businessFolder);
              }
            }
          });
        }
      });
    } else {
      this.isConfigurationVisible = false;
      if (this.selectedBusinessFolders.length != 0) {
        this.productFamily = this.masterProductFamily.filter(pf => this.selectedBusinessFolders.includes(pf.parent));
        if (this.selectedProductFamilyFolders.length == 0) {
          this.product = this.masterProduct.filter(pdt => this.productFamily.includes(pdt.parent));
        } else {
          this.product = this.masterProduct.filter(pdt => this.selectedProductFamilyFolders.includes(pdt.parent));
        }
      } else {
        this.businessStructure = this.masterBusinessStructure.filter(bs => bs.subFolders.some(sf => this.selectedProductFamilyFolders.includes(sf)));
        this.product = this.masterProduct.filter(pdt => this.productFamily.includes(pdt.parent));
        this.productFamily = this.masterProductFamily.filter(pf => this.businessStructure.includes(pf.parent));
      }
    }
  }

  onConfigurationChange() {
    if (this.selectedProductFamilyFolders.length == 0 && this.selectedBusinessFolders.length == 0 && this.selectedConfigurationFolders.length == 0) {
      this.product = this.masterProduct;
      return;
    }
    if (this.selectedConfigurationFolders.length !== 0) {
      this.selectedConfigurationFolders.forEach(conf => {
        if (!this.product.includes(conf.parent)) {
          this.product.push(conf.parent);
        }
      });
      return;
    }
    if (this.selectedBusinessFolders.length != 0) this.onBusinessStructureChange();
    if (this.selectedProductFamilyFolders.length != 0) this.onProductFamilyChange();
    if (this.selectedProductFolders.length != 0) this.onProductChange();
  }

  resetSelectedAttribute() {
    this.selectedBusinessFolders.forEach(sbf => {
      if (!this.businessStructure.includes(sbf)) {
        sbf.selected = false;
        this.selectedBusinessFolders = this.selectedBusinessFolders.filter(selectedItem => selectedItem != sbf);
      }
    });
    this.selectedProductFamilyFolders.forEach(spf => {
      if (!this.productFamily.includes(spf)) {
        spf.selected = false;
        this.selectedProductFamilyFolders = this.selectedProductFamilyFolders.filter(selectedItem => selectedItem != spf);
      }
    });
    this.selectedProductFolders.forEach(sp => {
      if (!this.product.includes(sp)) {
        sp.selected = false;
        this.selectedProductFolders = this.selectedProductFolders.filter(selectedItem => selectedItem != sp);
      }
    });
  }

  searchAssetsthroughFolder() {
    this.resetSelectedAttribute();
    let selectedFolders = [];
    this.selectedFoldersToSearch = '';
    if (this.selectedConfigurationFolders.length !== 0) {
      selectedFolders = this.selectedConfigurationFolders;
    } else if (this.selectedProductFolders.length !== 0) {
      selectedFolders = this.selectedProductFolders;
    } else if (this.selectedProductFamilyFolders.length !== 0) {
      selectedFolders = this.selectedProductFamilyFolders;
    } else if (this.selectedBusinessFolders.length !== 0) {
      selectedFolders = this.selectedBusinessFolders;
    }
    selectedFolders.forEach(selected => {
      this.selectedFoldersToSearch = this.selectedFoldersToSearch + (this.selectedFoldersToSearch !== '' ? ',' : '') + selected._id;
    });
    // if (!this.filterSelectionValues) {
    //   this.searchAssetsInFolder(this.selectedFoldersToSearch);
    // } else {
    //   this.searchAssetsInFolderWithFilter(this.selectedFoldersToSearch);
    // }
  }

  searchAssetsInFolder(selectedFoldersToSearch: any) {
    this.httpService.searchAssets(this.searchKey, this.userService.loggendInUser.userEmailId, selectedFoldersToSearch).subscribe(
      (data: any) => {
        this.searchResults = data.searchResults;
        this.filterKeys = data.filterByValues;
        event.target['value'] = this.searchKey;
        this.httpService.changesearchResults(this.searchResults, selectedFoldersToSearch, this.searchKey, this.filterKeys);
      },
      error => {
        this.httpService.changesearchResults('', ' ', '', null);
        this.assetsCardDetails = [];
      }
    );
  }

  searchAssetsInFolderWithFilter(selectedFoldersToSearch: any) {
    this.filterSelectionValues = {};
    this.filterSelectionValues = {
      "assetFileExtensionList": this.filterMap.get('extension'),
      "polygonCountList": [],
      "productStatusList": this.filterMap.get('restriction'),
      "tagsList": this.filterMap.get('tag'),
      "advanceList": []
    };
    this.httpService.applyFilters(this.searchKey, this.userService.loggendInUser.userEmailId, selectedFoldersToSearch, this.filterSelectionValues).subscribe(
      (response: any) => {
        this.assetsCardDetails = response.searchResults.assets;
        if (!this.searchResults) {
          this.searchResults = {};
        }
        this.searchResults.assets = response.searchResults.assets;
      },
      (err) => {
        this.assetsCardDetails = [];
        this.searchResults = {};
        // this.failureNotification("No Results found");
      }
    );
  }

  onSelectionChange(item: FolderStructure, fodlerLevel: number) {
    item.selected = false;
    switch (item.folderLevel | fodlerLevel) {
      case FolderLevel.BusinessStructure:
        this.selectedBusinessFolders = this.selectedBusinessFolders.filter(bf => bf._id != item._id);
        this.onBusinessStructureChange();
        break;
      case FolderLevel.ProductFamily:
        this.selectedProductFamilyFolders = this.selectedProductFamilyFolders.filter(pFF => pFF._id != item._id);
        this.onProductFamilyChange();
        break;
      case FolderLevel.Product:
        this.selectedProductFolders = this.selectedProductFolders.filter(pf => pf._id != item._id);
        this.onProductChange();
        break;
    }
    this.searchAssetsthroughFolder();
  }

  getShortenedNameForTag(tag: string) {
    if (tag && tag.length > 11) {
      return tag.substring(0, 11) + "...";
    } else {
      return tag;
    }
  }

  clearFilter() {
    this.resetFiltersControls();
    this.uncheckCheckbox();
    this.selectedSort = null;
    this.sortKey = 0;
    this.filterList.clear();
    this.targ = "";
    this.searchKeyForFilter = '';
    this.filterTagsArr = [];
    if (this.businessStructure.length > 0 || this.productFamily.length > 0 || this.product.length > 0)
      this.UncheckSeleted(this.businessStructure, this.productFamily, this.product, this.configurationFolders);
    this.applyFilters();
  }

  UncheckSeleted(BusinessCategory, ProductFamily, Product, configurationFolders) {

    for (var i = 0; i < BusinessCategory.length; i++) {
      if (BusinessCategory[i].selected == true) {
        BusinessCategory[i].selected = false;
      }
    }

    for (var i = 0; i < ProductFamily.length; i++) {
      if (ProductFamily[i].selected == true) {
        ProductFamily[i].selected = false;
      }
    }

    for (var i = 0; i < Product.length; i++) {
      if (Product[i].selected == true) {
        Product[i].selected = false;
      }
    }
    for (var i = 0; i < configurationFolders.length; i++) {
      if (configurationFolders[i].selected == true) {
        console.log(configurationFolders[i]);
        configurationFolders[i].selected = false;
      }
    }

    this.resetAllFolderDetails();
    this.setUpFolderStructure();
  }

  // modifyAssetStatus(){
  //   this.httpService.modifyAssetStatus(this.userService.loggendInUser.userEmailId,this.prodStatus,this.asset._id).subscribe((res)=>{
  //     // this.successNotification(res);
  //     this.asset.attributes.productStatus = this.prodStatus;
  //   }, (err)=>{
  //     // this.failureNotification("Error changing asset status");
  //     this.prodStatus = this.asset.attributes.productStatus;
  //   });
  // }

  checkModifyPermissions(): boolean {
    return this.userService.loggendInUser.applicationName.find(x => x.application === "VAL Web App").userGroup === "Admin";
  }

  checkModifyPermissionsForUploaders(): boolean {
    return this.userService.loggendInUser.applicationName.find(x => x.application === "VAL Web App").userGroup === "Admin" || this.userService.loggendInUser.applicationName.find(x => x.application === "VAL Web App").userGroup === "L1";
  }

  async applySelectedSavedFilter(filterArray: any) {
    this.isDisplayTags = true;
    this.selectedSort = null;
    this.resetFilterMap();
    this.checkedExtension = filterArray.extension;
    this.checkedExtension.forEach(element => {
      this.filterSelected(element, 'extension');
    });
    this.checkedRestrictions = filterArray.restriction;
    this.checkedRestrictions.forEach(element => {
      this.filterSelected(element, 'restriction');
    });
    this.checkedTags = filterArray.tag;
    this.checkedTags.forEach(element => {
      this.filterSelected(element, 'tag');
    });
    this.selectedFoldersToSearch = filterArray.businessCategory;
    try {
      await this.applyFilters();
      /**Selecting Sort By category*/
      switch (filterArray.sortKey) {
        case 0: this.selectedSort = 'Name';
          break;
        case 1: this.selectedSort = 'Ratings';
          break;
        case 2: this.selectedSort = 'Created Date';
          break;
        case 3: this.selectedSort = 'Updated Date';
          break;
        default: this.selectedSort = null;
      }
      if (filterArray.sortKey !== -1) {
        console.log(this.selectedSort);
        this.sortAssets(filterArray.sortKey);
      }
    } catch (error) {
      console.log(error);
    }
  }

  checkInput(val: string) {
    if (val === "") {
      this.filterNameValidFlag = false;
    }
    this.filterNameValidFlag = this.checkNameExists(val);
  }

  getRemix() {
    this.remixes = false;
    if (this.asset.remixedFrom != null) {
      this.httpService.getAssetById(this.asset.remixedFrom, this.userService.loggendInUser.userEmailId).subscribe(data => {
        this.assetRemixed = data;
        this.remix = true;
        this.assetRemixed.assetName = data.name;
        this.assetSuggestion = 2;
        this.assetRemixed["imageUrl"] = this.assetRemixed.assetfiles[0].uploadedImageURL[0];
        this.assetRemixed["rem"] = true;
        this.assetRemixed["visibility"] = this.assetRemixed.attributes.visibility;
        this.assetRemixed["primaryContactName"] = this.assetRemixed.attributes.primaryContact.name;
      });
    }
  }

  getRemixes() {
    this.assetRemixed = new Asset();
    this.remix = false;
    this.httpService.getAssetById(this.asset._id, this.userService.loggendInUser.userEmailId).subscribe(data => {
      this.remixedFromAsset = data.remixes;
      this.remixedFromAssetList = JSON.parse(JSON.stringify(this.remixedFromAsset));

      this.remixedFromAssetList.forEach(item => {
        item["rem"] = true;
      });

      if (this.remixedFromAssetList.length > 3) {
        this.remixedFromAssetList = this.remixedFromAssetList.splice(0, 3);
        this.isShowMoreVisible = true;
      }

      this.remixes = true;
      this.assetSuggestion = 3;
    });
  }

  showMoreRemixes() {
    this.remixedFromAssetList = JSON.parse(JSON.stringify(this.remixedFromAsset));
    this.isShowMoreVisible = false;
  }

  fetchUploaderProfileImage(userEmailId: string) {
    this.userService.fetchUserProfileImage(userEmailId).subscribe((userImage) => {
      if (userImage != null) {
        this.assetProfileImageURL = 'data:image/png;base64,' + userImage;
      }
      else {
        this.assetProfileImageURL = 'assets/img/userDefault.png';
      }
    },
      (err) => {
        console.log(err);
      });
  }

  changeActive(ev) {
    var elem = ev.target;
    if (this.previouseMenu != undefined && this.previouseMenu != elem)
      this.previouseMenu.removeAttribute("active");
    elem.setAttribute("active", "true");
    this.previouseMenu = elem;
  }

  openTab(evt, tabId: string, tabindex) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName('tabcontent');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    tablinks = document.getElementsByClassName('tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace("active", "");
    }

    document.getElementById(tabId).style.display = 'grid';
    evt.className += 'active';
    this.enableDownloadButtonForAsset = tabindex === 0;
  }

  checkUserDownloadPermission() {
    var userGroupforApplication = this.userService.loggendInUser.applicationName.find(x => x.userGroup === 'PrivilegedAccess');
    if (userGroupforApplication != undefined) {
      document.getElementById('fileTab').click();
      this.isConsentFormDownloadPermission = true;
      document.getElementById('defaultOpen').setAttribute('disabled', 'disabled');
    }
    else {
      document.getElementById('defaultOpen').click();
      this.isConsentFormDownloadPermission = false;
    }

    document.getElementById('Download').setAttribute('visible', 'true');
  }

  downloadFiles() {
    if (this.isConsentFormSelected === true) {
      this.httpService.downloadPrivilegedFiles(this.asset._id, this.userService.loggendInUser.userEmailId).subscribe(
        data => {
          this.successNotification("Successfully Downloaded the files");
          let fileElement = document.createElement("a"),
            url = URL.createObjectURL(new Blob([data], { type: "application/zip" }));
          fileElement.href = url;
          fileElement.download = this.asset.name;
          document.body.appendChild(fileElement);
          this.downloadValue = 90;
          fileElement.click();
          this.downloadStarted = false;
        },
        error => {
          this.failureNotification("File Not Found");
          this.downloadStarted = false;
        }
      );
    }
  }

  checkIfUserIsAdmin() {
    this.isAdminUser = false;
    this.userService.loggendInUser.applicationName.forEach((app) => {
      if (app.userGroup == 'Admin') {
        this.isAdminUser = true;
      }
    });
  }

  getExternalApplications() {
    this.userService.getExternalApplications().subscribe((res) => {
      this.applications = [];
      var userApps = JSON.parse(sessionStorage.userinfo).applicationName;
      var appIds = [];
      userApps.forEach(element => {
        appIds.push(element.application);
      });
      if (!this.isAdminUser) {
        res.forEach(element => {
          if (appIds.includes(element._id))
            this.applications.push(element);//to show only apps user have permission to
        });
      } else {
        this.applications = res;
        this.applications.forEach(element => {
          if (element.name == "VAL")
            element._id = "VAL Web App";
        });
      }
      sessionStorage.setItem("Applications", JSON.stringify(this.applications));
    });
  }

  updateApplicationId(appId) {
    this.asset["applicationId"] = appId._id;
  }

  filter(appId) {
    var res = this.applications.find(x => x._id == appId);
    console.log(res.name);
  }
}
